import React, { Component } from 'react'
import Link from 'gatsby-link'
import Img from 'gatsby-image'

class StoriesIndexPage extends Component {
  render() {
    const stories = [
      {
        link: 'richard-overton',
        title: 'Mr. Richard Overton',
        imgSizes: this.props.data.richardOverton.sizes,
        imgTitle: 'Richard Overton, World War II Veteran',
      },
      {
        link: 'campsey',
        title: 'The Campsey Family',
        imgSizes: this.props.data.campsey.sizes,
        imgTitle: 'The Campsey Family',
      },
      {
        link: 'jessica-foster',
        title: 'Jessica Foster',
        imgSizes: this.props.data.jessicaFoster.sizes,
        imgTitle: 'Jessica Foster, school teacher',
      },
    ]

    return (
      <div className="container p-5">
        <div className="row">
          <h1>Affordable Housing in Your Community</h1>
          <h2>
            Meet your neighbors who have created stability through the power of
            affordable housing.
          </h2>
        </div>
        <div className="row">
          {stories.map((story, i) => {
            return (
              <Link to={`/stories/${story.link}`} className="col-md" key={i}>
                <Img
                  title={story.imgTitle}
                  alt={story.imgTitle}
                  sizes={story.imgSizes}
                  style={{
                    marginTop: '20px',
                    width: '100%',
                    border: '3px solid black',
                    maxHeight: '275px',
                  }}
                />
                <h3 style={{ textAlign: 'center', marginTop: '20px' }}>
                  {story.title}
                </h3>
              </Link>
            )
          })}
        </div>
      </div>
    )
  }
}

export default StoriesIndexPage

export const query = graphql`
  query StoriesIndexPageQuery {
    richardOverton: imageSharp(id: { regex: "/Richard_Overton_Photo/" }) {
      sizes(maxWidth: 600, rotate: 180) {
        ...GatsbyImageSharpSizes
      }
    }
    campsey: imageSharp(id: { regex: "/campseys/" }) {
      sizes(maxWidth: 600, rotate: 180) {
        ...GatsbyImageSharpSizes
      }
    }
    jessicaFoster: imageSharp(id: { regex: "/Jessica_Foster_Frame/" }) {
      sizes(maxWidth: 600, rotate: 180) {
        ...GatsbyImageSharpSizes
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/stories/index.js